import { Table } from "@/features/Table";
import { type L1StaticDatum, porfolios_columns } from "./columns";
import {
  type FilterL1StaticDatumsSchema,
  FilterL1StaticDatums,
} from "./filter";

const client = "l1";
const table_name = "l1_static_data";

export const L1StaticDatumsTable = () => {
  return (
    <Table<L1StaticDatum, FilterL1StaticDatumsSchema>
      label="Actifs"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      filter={<FilterL1StaticDatums />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
